// extracted by mini-css-extract-plugin
module.exports = {"off-grid-F":"F_off-grid-F__i33ay"};